// eslint-disable-next-line require-jsdoc
import React from 'react';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import Tooltip from '@ids-beta/tooltip';
import { useState } from 'react';
import { colorPickerList } from '../../../assets/pagedata/constant';
import { isStockChangeTextAvil, sortColorOnStock } from '../Util/CommonUtils';

// eslint-disable-next-line require-jsdoc
export const ColorPicker = (props) => {
  const { supportedColors, defaultColor, pfid, allItem } = props;

  const [color, setColor] = React.useState(defaultColor);
  const [sortedColor, setSortedColor] = useState(supportedColors);


  useState(() => {
      const colorArray = sortColorOnStock(allItem, supportedColors);
      setSortedColor(colorArray);
      setColor(colorArray[0]);
      props.onColorPicked(colorArray[0]);
  });
  const handleColorChange = (_, newColor) => {
    if (newColor !== null) {
      setColor(newColor);
      props.onColorPicked(newColor);
    }
  };

  return (
    <div>
      <p className="color-picker">
        Select folder color
        {isStockChangeTextAvil({
          pfid,
        }) && <sup> 1</sup>}
      </p>
      <ToggleButtonGroup
        value={color}
        exclusive
        onChange={handleColorChange}
        aria-label="color picker"
        className="margin-bottom-20 color-toggle-button"
      >
        {sortedColor.map((el, key) => {
          const colorPicker = colorPickerList.find((x) => x.color === el);
          return (
            <ToggleButton
              key={key}
              value={colorPicker.color}
              aria-label="centered"
              data-wa-link={colorPicker.color}
              data-ui-object="segmented_button"
              data-refer-ui-access-point={`color_picker | ${colorPicker.color}`}
              data-ui-object-details="Select folder color"
            >
              <Tooltip
                role="tooltip"
                automationId="tooltip_custom"
                message={
                  <div>
                    <span>{el}</span>
                  </div>
                }
              >
                <img src={colorPicker.imageurl} alt="Select folder color: Regal" />
              </Tooltip>
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </div>
  );
};
